import { parseAppEnvironment, type AppEnvironment } from "./environment";

export const CURRENT_APP_ENVIRONMENT = parseAppEnvironment(
  process.env.REACT_APP_APP_ENV,
);

export function isPreviewEnvironment(environment: AppEnvironment): boolean {
  return environment === "staging";
}

function normalizePath(pathname: string): string {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
}

// P3 expose une seule surface fonctionnelle. Toute nouvelle route demeure
// masquée en STAGING jusqu'à une promotion explicite et testée.
export function isRouteAvailableInEnvironment(
  pathname: string,
  environment: AppEnvironment,
): boolean {
  if (!isPreviewEnvironment(environment)) return true;
  return normalizePath(pathname) === "/";
}
